const es = {
  'language.english': 'Inglés',
  'language.spanish': 'Español',
};

export default es;
